import React, {useEffect, useState} from 'react';
import { Flex} from "antd";
import {StyledCard} from "./DetailCards.styled";
import style from "./DetailCards.module.scss";
import {
    LeftOutlined
} from '@ant-design/icons';
import {IoShieldCheckmarkOutline} from "react-icons/io5";
import GuaranteePopUp from "../guaranteePopUp/GuaranteePopUp";
import {GuaranteeCardProps} from "../../../models";
const GuaranteeCard = ({product} : GuaranteeCardProps) => {
    const [open, setOpen] = useState<boolean>(false)
    const [activeGuarantee, setActiveGuarantee] = useState<any>()

    useEffect(() => {
        product?.productAssurances?.length > 0 &&  setActiveGuarantee(product?.productAssurances.reduce((minItem:any, item:any) => item.productAssuranceTypeId < minItem.productAssuranceTypeId ? item : minItem, product?.productAssurances[0]))
    }, [product]);

    const openGuaranteeModal = () => {
        setOpen(true)
    }
    const onCansel = () => {
        setOpen(false)
    }
    return (
     <>   <StyledCard className={'shadow-sm'} onClick={openGuaranteeModal}  >
            <Flex justify={"space-between"} align={"center"}>
                <Flex gap={"middle"}>
                   <span> <IoShieldCheckmarkOutline  className={style.icons}/> تضامین </span>
                </Flex>
                <Flex gap={"small"}>
                    {product?.productAssurances?.length > 1 ?
                        <span
                            className={style.greyText}>{`${activeGuarantee?.title} و ${product?.productAssurances?.length - 1} مورد دیگر`}</span>
                        :
                        <span className={style.greyText}>{activeGuarantee?.title}</span>
                    }


                    <span> <LeftOutlined className={style.icons}/> </span>
                </Flex>

            </Flex>
     </StyledCard>
         <GuaranteePopUp product={product} open={open} onCansel={onCansel}/>
     </>
    );
};

export default GuaranteeCard;
